<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th>Grupo</th>
          <th>Nome</th>
          <th class="text-center">Status</th>
          <th>Criado por</th>
          <th>Atualizado por</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="survey in surveys" :key="survey.id">
          <td class="text-center">{{ survey.id }}</td>
          <td>{{ survey.groupName }}</td>
          <td>{{ survey.name }}</td>
          <td v-html="statusTranslate(survey.status)" class="text-center" />
          <td>
            {{ createdUpdatedUser(survey.createdBy, survey.createdAt) }}
          </td>
          <td>
            {{ createdUpdatedUser(survey.updatedBy, survey.updatedAt) }}
          </td>
          <td class="text-center p-2">
            <router-link
              type="button"
              :to="{
                name: 'ParamsSurveysDetails',
                params: { surveyId: survey.id },
              }"
              class="btn btn-outline-primary btn-icon"
              title="Detalhar"
            >
              <i class="ph ph-eye" />
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'

export default {
  name: 'ListSurveys',

  props: {
    surveys: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListSurveys',
        columnDefs: [
          {
            targets: [4, 5, 6],
            orderable: false,
          },
          {
            targets: [6],
            width: 100,
          },
        ],
      },
      createdUpdatedUser,
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
